
import { useCallback } from "react";
import { logger } from "@/lib/logger";

export function useStaffIdValidator() {
  const validateStaffId = useCallback((staffId?: string) => {
    // Check if staffId is actually a placeholder or invalid
    if (staffId && (staffId === ':staffId' || !staffId.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i))) {
      logger.warn({
        message: "Invalid staffId format received",
        context: { staffId }
      });
      return false;
    }
    return true;
  }, []);

  return { validateStaffId };
}
